// ─────────────────────────────────────────────────────────────────────────────
// Card.js — the translucent "glass" panel every Dashboard section sits in, plus
// the empty state its body falls back to.
//
// The design gives the five panels three different title treatments, so the
// heading font is a `variant` rather than five near-identical card components:
//   mono   — uppercase JetBrains-style caption (Recent Alerts, Network Bandwidth)
//   retro  — the Retrotech display face      (Traffic by Region, User Activity)
//   ui     — semibold Inter                  (Recent Admin Actions)
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./Card.module.css";

const TITLE_VARIANTS = {
  mono:  styles.titleMono,
  retro: styles.titleRetro,
  ui:    styles.titleUi,
};

/**
 * @param {object}    props
 * @param {string}    props.title
 * @param {"mono"|"retro"|"ui"} [props.variant="mono"]
 * @param {ReactNode} [props.action]  right-hand header slot (badge, select, …)
 * @param {boolean}   [props.wide]    let the card flex-grow inside its row
 */
export default function Card({ title, variant = "mono", action, wide = false, children }) {
  return (
    <div className={`${styles.card} ${wide ? styles.wide : ""}`}>
      <div className={styles.header}>
        <span className={TITLE_VARIANTS[variant] ?? styles.titleMono}>{title}</span>
        {action}
      </div>
      {children}
    </div>
  );
}

/** What a panel shows when its slice of the payload never arrived. */
export function EmptyState({ children }) {
  return <div className={styles.empty}>{children}</div>;
}
